import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../content/SiteContext';
import { formatMessage, whatsappLink, track } from '../lib/contact';
import { PageMeta, PageHero, SectionHead, CtaBand, CheckList, Price, FaqList } from '../components/ui';

const PLAN_FAQS = [
  { q: 'How do I start a monthly plan?', a: 'Choose a plan and message us on WhatsApp. We confirm your location, the plan terms and your first wash before you pay.' },
  { q: 'Is a monthly plan cheaper than single washes?', a: 'The Premium Plan gives you 8 Deluxe Washes for AED 240 instead of AED 360 if booked individually. The Basic Plan costs the same per wash as single Basic Washes and adds priority booking.' },
  { q: 'Which areas do plans cover?', a: 'Monthly plans are available in the areas we serve in Abu Dhabi and Dubai.' },
  { q: 'Can I change or cancel my plan?', a: 'Message us on WhatsApp. The terms for changing or cancelling are confirmed with you when you subscribe.' }
];

const planMessage = (p) => formatMessage('Hi Quick Way, I am interested in a monthly plan.', [['Plan', `${p.name} (AED ${p.price}/month)`]]);

const Membership = () => {
  const { PLANS } = useSite();
  return (
  <>
    <PageMeta
      title="Monthly Car Wash Subscription Dubai & Abu Dhabi | Quick Way"
      description="Monthly car wash plans at your home or office in Abu Dhabi and Dubai. 4 washes for AED 120 or 8 Deluxe Washes for AED 240, with priority booking."
      path="/membership"
      crumbs={[{ name: 'Membership', path: '/membership' }]}
    />
    <PageHero eyebrow="Monthly plans" title="Monthly car wash plans">
      <p>Keep your car clean all month with regular washes at your location and priority booking. Plans are available in Abu Dhabi and Dubai.</p>
    </PageHero>

    <section className="section">
      <div className="container">
        <div className="grid grid-3">
          {PLANS.map((p) => (
            <article key={p.id} className={`pkg-card${p.featured ? ' pkg-card--featured' : ''}`}>
              {p.featured && <span className="pkg-card__badge">Best value</span>}
              <h2 className="pkg-card__name">{p.name}</h2>
              <p className="pkg-card__summary">{p.washes}</p>
              <div className="pkg-card__price"><Price value={p.price} suffix="/ month" /></div>
              <p className="pkg-card__meta">{p.perWash}</p>
              <CheckList items={p.features} />
              <p className="pkg-card__note">{p.note}</p>
              <div className="pkg-card__actions">
                <a href={whatsappLink(planMessage(p))} target="_blank" rel="noopener noreferrer"
                  className={`btn ${p.featured ? 'btn-primary' : 'btn-outline-dark'} btn-block`}
                  onClick={() => track('generate_lead', { lead_type: 'membership', plan: p.id })}>
                  Ask about {p.name}
                </a>
              </div>
            </article>
          ))}
        </div>
        <p className="center-note muted">Plan terms are confirmed on WhatsApp before you subscribe. Prefer a one-off wash? Order in the Quick Way app or <Link to="/book">book online</Link>.</p>
      </div>
    </section>

    <section className="section section--tint">
      <div className="container container--narrow">
        <SectionHead title="Monthly plan questions" />
        <FaqList items={PLAN_FAQS} />
      </div>
    </section>

    <CtaBand source="membership" />
  </>
);
};

export default Membership;
